<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputText name="Durezza totale dell'acqua" v-model="implant.water_hardness" />
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Trattamento acqua impianto climatizzazione"
        v-model="implant.heating_treatment"
        :options="['Assente', 'Filtrazione', 'Addolcimento']"
        :multiple="true"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="implant.heating_treatment?.includes('Addolcimento')">
      <InputText name="Durezza totale acqua impianto °fr" v-model="implant.heating_treatment_water_hardness" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="implant.heating_treatment?.includes('Addolcimento')">
      <div class="field">
        <label class="label">Condizionamento chimico</label>
        <div class="control is-flex">
          <label class="checkbox">
            <input type="checkbox" v-model="implant.heating_treatment_conditioning">
          </label>
        </div>
      </div>
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Trattamento acqua calda sanitaria"
        v-model="implant.domestic_hot_water_treatment"
        :options="['Assente', 'Filtrazione', 'Addolcimento']"
        :multiple="true"
      />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="implant.domestic_hot_water_treatment?.includes('Addolcimento')">
      <InputText name="Durezza totale acqua impianto °fr" v-model="implant.domestic_hot_water_treatment_water_hardness" />
    </div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="implant.domestic_hot_water_treatment?.includes('Addolcimento')">
      <div class="field">
        <label class="label">Condizionamento chimico</label>
        <div class="control is-flex">
          <label class="checkbox">
            <input type="checkbox" v-model="implant.domestic_hot_water_treatment_conditioning">
          </label>
        </div>
      </div>
    </div>

    <div class="column is-12 p-0"></div>

    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Trattamento acqua raffreddamento impianto climatizzazione estiva"
        v-model="implant.cooling_treatment"
        :options="['Assente', 'Filtrazione', 'Trattamento acqua', 'Condizionamento chimico']"
        :multiple="true"
      />
    </div>
  </div>
</template>
  
<script>
export default {
  props: {
    implant: Object
  },
  emits: ['update:implant'],

  methods: {
    
  }
}
</script>